import { createContext } from 'react';
import { Organization } from 'src/models/organization';

export interface OrganizationContextType {
  organizations: Organization[];
  currentOrg: string | null;
  setCurrentOrg: (org: string | null) => void;
  fetchOrganizationById: (organizationId: string) => Promise<Organization | null>;
  fetchAllOrganizations: () => void;
  deleteOrganization: (organizationId: string) => Promise<boolean>;
  editOrganization: (organizationData: Partial<Organization> & { _id: string }) => void;
  handleOrganizationSwitchAndExit: (organizationId: string | null) => void;
}

export const OrganizationContext = createContext<OrganizationContextType>(
  {} as OrganizationContextType
);
